import {
  Alert,
  Button,
  ButtonProps,
  Group,
  Popover,
  PopoverProps,
  UnstyledButton,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconAlertCircle } from "@tabler/icons";
import React, { ReactNode } from "react";

export interface IPopconfirmProps extends PopoverProps {
  title: string;
  description?: ReactNode | string;
  onConfirm?: (e?: React.MouseEvent<HTMLElement>) => void;
  onCancel?: (e?: React.MouseEvent<HTMLElement>) => void;
  okText?: ReactNode;
  okButtonProps?: ButtonProps;
  cancelText?: React.ReactNode;
  cancelButtonProps?: ButtonProps;
  targetButtonProps?: ButtonProps;
  showCancel?: boolean;
  icon?: ReactNode;
}

export const Popconfirm = (props: IPopconfirmProps) => {
  const {
    defaultOpened,
    children,
    onConfirm,
    onCancel,
    closeOnEscape = true,
    closeOnClickOutside = false,
    title,
    description,
    icon,
    okText,
    cancelText,
    okButtonProps,
    cancelButtonProps,
    targetButtonProps,
    ...rest
  } = props;
  const [opened, { close, open }] = useDisclosure(defaultOpened ?? false);

  const handleConfirm = (e: React.MouseEvent<HTMLButtonElement>) => {
    props.onConfirm?.(e);
    close();
  };

  const handleCancel = (e: React.MouseEvent<HTMLButtonElement>) => {
    props.onCancel?.(e);
    close();
  };

  return (
    <>
      <Popover
        withArrow
        shadow="xs"
        closeOnClickOutside={closeOnClickOutside}
        opened={opened}
        {...rest}
      >
        <Popover.Target>
          <UnstyledButton onClick={open}>{children}</UnstyledButton>
        </Popover.Target>
        <Popover.Dropdown p={0}>
          <Alert
            title={title}
            color="red"
            icon={icon ?? <IconAlertCircle size={16} />}
          >
            {description}
            <Group position="right" mt="sm" spacing="xs">
              <Button size="xs" {...okButtonProps} onClick={handleConfirm}>
                {okText ?? "OK"}
              </Button>
              <Button
                size="xs"
                variant="default"
                {...cancelButtonProps}
                onClick={handleCancel}
              >
                {cancelText ?? "Cancel"}
              </Button>
            </Group>
          </Alert>
        </Popover.Dropdown>
      </Popover>
    </>
  );
};
